module.exports = __webpack_public_path__ + "static/media/image-primary2.763202a5.svg";